// extracted by mini-css-extract-plugin
export var externalLink = "_df-0";
export var internalLinkLabel = "_df-1";